<app-nav></app-nav>
<div class="container-fluid">
  <div class="inner-wrap">
      <div *ngIf="isLoading">
          <div class="spinner-container">
              <spinner loadingText="Loading...Please wait."></spinner>
          </div>
      </div>
      <div class="jumbotron" *ngIf="noPostsFound">
        <div class="container">
          <h1 id="title" class="display-4">No posts for {{location}} yet...</h1>
          <button class="btn btn-primary mt-2 mb-4" (click)="createPost()">Create First Post</button>
        </div>
        <div class="container">
           <img src="../../assets/img/city_page.jpg" class="img-fluid">
        </div>
      </div>
      <div *ngIf="!noPostsFound">

        <div class="container-fluid">
          <h1 id="title" class="title mt-2 mb-3 font-weight-bold">{{location}}</h1>
          <button class="btn btn-primary mb-2" (click)="createPost()">Create New Post</button>
          <div class="input-group mt-2 mb-2">
            <select type="text" class="form-control" placeholder="Bars" [formControl]="bar">
              <option></option>
              <option *ngFor = "let bar of (barsInLoc | uniqueBarName)">{{bar | barName}}</option>
            </select>
            <div class="input-group-append">
              <button class="btn btn-primary mr-3" (click)="searchBar()">Search Bar</button>
            </div>
            <input type="text" class="form-control" placeholder="Users" [formControl]="user">
            <div class="input-group-append">
              <button class="btn btn-primary" (click)="searchUser()">Search User</button>
            </div>
          </div>
          <div class="input-group mt-3 mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text">Filter By: </label>
            </div>
            <select class="form-control mr-3" id="filter" (change)="selectFilter()">
              <option>Time</option>
              <option disabled selected>Rating</option>
            </select>
            <select type="text" class="form-control" placeholder="Neighborhood" [formControl]="nbhood">
              <option></option>
              <option *ngFor = "let bar of (barsInNbhood | uniqueNbhoodName)">{{bar | barName}}</option>
            </select>
            <div class="input-group-append">
              <button class="btn btn-primary mr-3" (click)="searchNbhood()">Search Area</button>
            </div>
        </div>

        <div class="list-group-container" 
          infinite-scroll
          [infiniteScrollDistance]="2"
          [infiniteScrollThrottle]="350"
          (scrolled)="onScrollDown()">
          <ul class="list-group">
              <li class="list-group-item" *ngFor="let post of locationPosts">
                  <app-post [post]='post'></app-post>
              </li>
          </ul>
       

          <div class="list-loading" *ngIf="isListLoading">
            <div class="spinner-container">
                <spinner></spinner>
            </div>
          </div>
        </div>

      </div>
  </div>
</div>